import { badgeVariantsClientBadge } from '@/components/ui/StatusBadge/StatusBadgeClient';
import { StateClient } from '@/interfaces';
import { VariantProps } from 'class-variance-authority';

export const stateToVariantClient: Record<
	StateClient,
	VariantProps<typeof badgeVariantsClientBadge>['variant']
> = {
	[StateClient.POTENCIAL]: 'Potencial',
	[StateClient.ACTIVO]: 'Activo',
	[StateClient.INACTIVO]: 'Inactivo',
};

/**
 * Nombre con el que se identifica al cliente en facturas y presupuestos:
 * la razón social. Si la ficha no la tiene, se usa el nombre comercial.
 */
export const clientLegalName = (
	client?: { companyName?: string; tradeName?: string } | null,
): string | undefined => client?.companyName || client?.tradeName || undefined;
